import type { ComponentType, ReactNode } from "react";
import { DialogDescription, DialogHeader, DialogTitle, cn } from "@nexus/ui";

export type DialogIconTone = "neutral" | "primary" | "destructive";

const TONE_CLASS: Record<DialogIconTone, { bg: string; icon: string }> = {
  neutral: { bg: "bg-muted", icon: "text-muted-foreground" },
  primary: { bg: "bg-primary/10", icon: "text-primary" },
  destructive: { bg: "bg-destructive/10", icon: "text-destructive" },
};

interface DialogIconHeaderProps {
  icon: ComponentType<{ className?: string }>;
  tone?: DialogIconTone;
  title: ReactNode;
  description: ReactNode;
  /** Extra classes on the header wrapper (e.g. `pr-14` to clear a modal's close button). */
  className?: string;
}

/** Icon + title + description header shared by the IAM dialogs' bordered header block. */
export function DialogIconHeader({ icon: Icon, tone = "neutral", title, description, className }: DialogIconHeaderProps) {
  const { bg, icon } = TONE_CLASS[tone];

  return (
    <DialogHeader className={cn("border-b border-border px-6 py-4", className)}>
      <div className="flex items-center gap-3">
        <div className={cn("flex h-9 w-9 shrink-0 items-center justify-center rounded-lg", bg)}>
          <Icon className={cn("h-4 w-4", icon)} />
        </div>
        <div>
          <DialogTitle className="text-base font-semibold">{title}</DialogTitle>
          <DialogDescription className="text-[12px]">{description}</DialogDescription>
        </div>
      </div>
    </DialogHeader>
  );
}
